import React, { useState } from "react";
import { Col, Form, Label, Row } from "reactstrap";
import ResponsiveDatePickers from "../../../../components/date-picker";
import toast from "react-hot-toast";

const FormBase = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const validateDates = (start, end) => {
    console.log("start: ", start)
    console.log("end: ", end)
    if (start && end) {
      if (start > end) {
        toast.error("La fecha 'Desde' no puede ser mayor que la fecha 'Hasta'.");
        return false;
      }
      if (end < start) {
        toast.error("La fecha 'Hasta' no puede ser menor que la fecha 'Desde'.");
        return false;
      }
    }
    return true;
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    validateDates(date, endDate);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    validateDates(startDate, date);
  };

  return (
    <React.Fragment>
      <Row className="mb-1">
        <Col md="6" sm="12">
          <Label className="me-1" for="start-date-picker">
            Desde
          </Label>
          <div className="mb-50">
            <ResponsiveDatePickers
              value={startDate}
              onChange={handleStartDateChange}
              disableFuture
              Label=""
              placeholder="Selecciona una fecha"
              datePickerHeight="0px"
            />
          </div>
        </Col>
        <Col md="6" sm="12">
          <Label className="me-1" for="end-date-picker">
            Hasta
          </Label>
          <div className="mb-50">
            <ResponsiveDatePickers
              value={endDate}
              onChange={handleEndDateChange}
              disableFuture
              Label=""
              placeholder="Selecciona una fecha"
              datePickerHeight="0px"
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default FormBase;
